import { getRepository } from './repository';

const resource = "/upload";

export default {
    list(headers) {
        return getRepository().get(`${resource}/list`, {headers : headers});
    },
    add(filename, headers) {
        return getRepository().post(`${resource}/add`, filename, {headers : headers});
    },
    complete(uploadId, headers) {
        return getRepository().post(`${resource}/complete`, {"upload_id" : uploadId}, {headers : headers})
    },
    deleteImg(imgId, headers) {
        return getRepository().post(`${resource}/remove`, {"id" : imgId}, {headers : headers})
    },
    listDetails(imgId, headers) {
        return getRepository().get(`${resource}/details/${imgId}`, {headers : headers});
    },
};